exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nK1gnmEYDD32cPo1ni4S7{font-weight:400;top:50px}html[dir] ._1nK1gnmEYDD32cPo1ni4S7 .ms-Panel-contentInner{padding-top:15px}.Fjp5SeJ8EGGoEg5M7UCcR{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:calc(100vh - 180px);overflow:hidden}._3NfsrTXiu1ua2ci4yX1sV3{overflow:auto}._3r1GgirN6MnkGYfdjwFAoU,._3NfsrTXiu1ua2ci4yX1sV3{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._3r1GgirN6MnkGYfdjwFAoU{margin:0 15px}", ""]);
// Exports
exports.locals = {
	"main": "_1nK1gnmEYDD32cPo1ni4S7",
	"container": "Fjp5SeJ8EGGoEg5M7UCcR",
	"table": "_3NfsrTXiu1ua2ci4yX1sV3",
	"details": "_3r1GgirN6MnkGYfdjwFAoU"
};